(function () {
  function getSelectedQuantityBreak(quantityBreaks) {
    var checkedInput = quantityBreaks.querySelector('input[name="quantity"]:checked');
    if (!checkedInput) {
      checkedInput = quantityBreaks.querySelector('input[name="quantity"]');
    }

    if (!checkedInput || !checkedInput.dataset.input) {
      return null;
    }

    var quantityBreak = Array.prototype.find.call(
      quantityBreaks.querySelectorAll(".quantity-break"),
      function (breakElement) {
        return breakElement.dataset.input === checkedInput.dataset.input;
      }
    );

    return {
      input: checkedInput,
      quantityBreak: quantityBreak,
    };
  }

  function repeatVariantId(variantId, quantity) {
    var ids = [];
    for (var index = 0; index < quantity; index += 1) {
      ids.push(variantId);
    }
    return ids;
  }

  function getQuantityBreakVariantIds(selected, productForm, quantity) {
    var selectorItems = selected.quantityBreak
      ? selected.quantityBreak.querySelectorAll(".quantity-break__selector-item")
      : [];
    var selectedIds = Array.prototype.map
      .call(selectorItems, function (item) {
        return item.dataset.selectedId;
      })
      .filter(Boolean);

    if (selectedIds.length > 0) {
      return selectedIds;
    }

    var mainVariantInput = productForm.querySelector('input[name="id"]');
    if (!mainVariantInput || !mainVariantInput.value || quantity < 1) {
      return [];
    }

    return repeatVariantId(mainVariantInput.value, quantity);
  }

  function syncQuantityBreaksForSubmit(productForm) {
    if (!productForm || !productForm.dataset.section) {
      return;
    }

    var quantityBreaks = document.getElementById("quantity-breaks-" + productForm.dataset.section);
    if (!quantityBreaks) {
      return;
    }

    var selected = getSelectedQuantityBreak(quantityBreaks);
    if (!selected) {
      return;
    }

    var quantity = parseInt(selected.input.value, 10);
    if (!Number.isFinite(quantity)) {
      quantity = 1;
    }

    var selectedIds = getQuantityBreakVariantIds(selected, productForm, quantity);
    if (selectedIds.length === 0) {
      return;
    }

    quantityBreaks.selectedQuantity = quantity;
    quantityBreaks.formVariants = selectedIds;

    if (quantityBreaks.selectedVariants && selected.input.dataset.input) {
      quantityBreaks.selectedVariants[selected.input.dataset.input] = selectedIds;
    }
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.matches('form[data-type="add-to-cart-form"]')) {
        return;
      }

      syncQuantityBreaksForSubmit(form.closest("product-form"));
    },
    true
  );
})();
